<mat-sidenav-container class="h-[100vh] overflow-hidden z-auto">
	<mat-sidenav class="subnav-container" mode="side" opened #sidenav onpause="">
		<h2 class="text-xl mb-4">Settings</h2>
		<hr aria-hidden="true" class="subnav-divider" />

		<nav class="subnav">
			<h3 class="subnav__heading">Business</h3>
			<ul class="subnav__list">
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageBusinessDetailsUrl"
						data-intercom-target="business-details"
					>
						<app-icon
							[icon]="ICON.BUILDING"
							class="subnav__link-icon"
						></app-icon>
						<span class="subnav__link-text">Details</span>
					</a>
				</li>
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageBusinessDefaultsUrl"
						data-intercom-target="business-defaults"
					>
						<app-icon [icon]="ICON.CODE" class="subnav__link-icon"></app-icon>
						<span class="subnav__link-text">Defaults</span>
					</a>
				</li>
				<li class="subnav__list-item" *ngIf="!isCollege">
					<a
						class="subnav__link"
						[routerLink]="manageBillingUrl"
						data-intercom-target="business-billing"
					>
						<app-icon
							[icon]="ICON.FILE_INVOICE_DOLLAR"
							class="subnav__link-icon"
						></app-icon>
						<span class="subnav__link-text">Billing</span>
					</a>
				</li>
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageBusinessSecurityUrl"
						data-intercom-target="business-security"
					>
						<app-icon
							[icon]="ICON.SECURITY"
							class="subnav__link-icon"
						></app-icon>
						<span class="subnav__link-text">Security</span>
					</a>
				</li>
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageTrustAccountsUrl"
						data-intercom-target="business-trust-accounts"
					>
						<app-icon
							[icon]="ICON.FUNDING_METHOD"
							class="subnav__link-icon"
						></app-icon>
						<span class="subnav__link-text">Funding Methods</span>
					</a>
				</li>
			</ul>
			<hr aria-hidden="true" class="subnav-divider" />

			<h3 class="subnav__heading">Users</h3>
			<ul class="subnav__list">
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageUsersUrl"
						data-intercom-target="business-users"
					>
						<app-icon [icon]="ICON.USERS" class="subnav__link-icon"></app-icon>
						<span class="subnav__link-text">Users</span>
					</a>
				</li>
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageInvitesUrl"
						data-intercom-target="business-invites"
					>
						<app-icon
							[icon]="ICON.ENVELOPE"
							class="subnav__link-icon"
						></app-icon>
						<span class="subnav__link-text">Invites</span>
					</a>
				</li>
			</ul>
			<hr class="subnav-divider" aria-hidden="true" />

			<h3 class="subnav__heading">Templates</h3>
			<ul class="subnav__list">
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageBusinessDocumentTemplatesUrl"
						data-intercom-target="business-templates"
					>
						<app-icon [icon]="ICON.FILE" class="subnav__link-icon"></app-icon>
						<span class="subnav__link-text">Documents</span>
					</a>
				</li>
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageBusinessRequisitionTemplatesUrl"
						data-intercom-target="business-templates-requisitions"
					>
						<app-icon [icon]="ICON.LIST" class="subnav__link-icon"></app-icon>
						<span class="subnav__link-text">Requisitions</span>
					</a>
				</li>
			</ul>
			<hr class="subnav-divider" aria-hidden="true" />

			<h3 class="subnav__heading">General</h3>
			<ul>
				<li>
					<a
						class="subnav__link"
						[routerLink]="financesGeneralUrl"
						data-intercom-target="business-finances"
					>
						<app-icon
							[icon]="ICON.SLIDERS"
							class="subnav__link-icon"
						></app-icon>
						<span class="subnav__link-text whitespace-nowrap"
							>General settings</span
						>
					</a>
				</li>

				<li>
					<a class="subnav__link" [routerLink]="checklistUrl">
						<app-icon
							[icon]="ICON.CHECKLIST"
							[iconStyle]="ICON_STYLE.SOLID"
							class="subnav__link-icon"
						></app-icon>
						<span class="subnav__link-text">Checklists</span>
					</a>
				</li>

				<li>
					<a
						class="subnav__link"
						[routerLink]="manageBusinessDocumentStylingUrl"
						data-intercom-target="business-document-styling"
					>
						<app-icon
							[icon]="ICON.SLIDERS"
							class="subnav__link-icon"
						></app-icon>
						<span class="subnav__link-text">Document styling</span>
					</a>
				</li>
			</ul>
			<hr class="subnav-divider" aria-hidden="true" />

			<h3 class="subnav__heading">Integrations</h3>
			<ul class="subnav__list">
				<li class="subnav__list-item">
					<a
						class="subnav__link"
						[routerLink]="manageIntegrationsUrl"
						data-intercom-target="business-integrations"
					>
						<app-icon [icon]="ICON.PUZZLE" class="subnav__link-icon"></app-icon>
						<span class="subnav__link-text">Manage</span>
					</a>
				</li>
			</ul>
		</nav>
	</mat-sidenav>
	<mat-sidenav-content class="z-auto">
		<router-outlet></router-outlet>
	</mat-sidenav-content>
</mat-sidenav-container>
